<script>
export default {
	name: 'TDestinationDot',
	functional: true,
	props: {
		type: {
			type: String,
			default: 'grey',
			validator(val) {
				return	[ 'grey', 'green', 'orange' ].indexOf(val) > -1;
			}
		}
	},
	data() {
		return { color: '#c7ced4', size: '12px', checkMark: false };
	},

	render(_, context) {
		let dotStyle = getStyleByType(context.props.type);
		return (
			<svg width={dotStyle.size} height={dotStyle.size} viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" {...context.data}>
				<circle fill={dotStyle.color} cx="6" cy="6" r="6"></circle>
				{context.props.type === 'green' &&
				<path transform="translate(-.5, -.5)" d="M9.5,4 C9.36,4 9.235,4.055 9.145,4.145 L5.5,7.795 L3.855,6.145 C3.765,6.055 3.64,6 3.5,6 C3.225,6 3,6.225 3,6.5 C3,6.64 3.055,6.765 3.145,6.855 L5.145,8.855 C5.235,8.945 5.36,9 5.5,9 C5.64,9 5.765,8.945 5.855,8.855 L9.855,4.855 C9.945,4.765 10,4.64 10,4.5 C10,4.225 9.775,4 9.5,4 Z" fill="#FFFFFF" fill-rule="nonzero"></path>
				}
			</svg>
		);
	}
};

function getStyleByType(type) {
	let dotStyle = {
		color: '#c7ced4',
		size: '10px'
	};

	if (type === 'green') {
		return {
			color: '#47b881',
			size: '14px'
		};
	} else if (type === 'orange') {
		return {
			...dotStyle,
			color: '#f7d154'
		};
	} else {
		return dotStyle;
	}
}
</script>
